import { LD_FF_URL_BASE } from './open-launch-darkly-url.constants';

/**
 * Opens a new Launch Darkly dashboard tab for the provided feature flag.
 */
export function openLaunchDarklyUrl(flagKey: string) {
  window.open(`${LD_FF_URL_BASE}/${flagKey}`, '_blank');
}
